import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import brandIcon from "assets/images/logo.png"; // Use your brand icon here
import { postRequest } from "../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformApiConfigurationModal = ({ platformName, headers, isOpen, onClose, handleFetchConnectedPlatforms }) => {
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [adminApiToken, setAdminApiToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const saveShopifyApiCredentials = async () => {
    // Check if all fields are filled
    if (!apiKey || !apiSecret || !adminApiToken) {
      setError("All fields are required!");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Replace the URL with your actual API endpoint
      await postRequest("/api/connected-platforms/save-shopify-credentials", {
        apiKey,
        apiSecret,
        adminApiToken,
        platform: platformName
      }, { ...headers });

      toast.success("API credentials saved successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      console.error(err)
      setError("An error occurred while saving the credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
          {/* Close Icon */}
          <button
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
            onClick={onClose}
          >
            <FaTimes size={20} />
          </button>

          {/* Brand Icon */}
          <div className="flex items-center gap-2 mb-4">
            <img
              src={brandIcon}
              alt={"Your Brand"}
              className="flex-grow-0"
              style={{ height: "20px" }}
            />
          </div>

          {/* Heading and Subheading */}
          <h2 className="text-lg font-bold text-gray-800 mb-2">
            API Configuration
          </h2>
          <p className="text-sm text-gray-600 mb-4">
            Please provide your API credentials.
          </p>

          {/* API Key, API Secret, Admin API Access Token Inputs */}
          <div className="space-y-4">
            <div className="mb-3">
              <label
                htmlFor="apiKey"
                className="block text-sm font-medium text-gray-700"
              >
                API Key
              </label>
              <input
                type="text"
                required="true"
                id="apiKey"
                className="mt-1 p-2 w-full border rounded-lg"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Enter your API Key"
              />
            </div>

            <div className="mb-3">
              <label
                htmlFor="apiSecret"
                className="block text-sm font-medium text-gray-700"
              >
                API Secret
              </label>
              <input
                type="text"
                required="true"
                id="apiSecret"
                className="mt-1 p-2 w-full border rounded-lg"
                value={apiSecret}
                onChange={(e) => setApiSecret(e.target.value)}
                placeholder="Enter your API Secret"
              />
            </div>

            <div className="mb-3">
              <label
                htmlFor="adminApiToken"
                className="block text-sm font-medium text-gray-700"
              >
                Admin API Access Token
              </label>
              <input
                type="text"
                required="true"
                id="adminApiToken"
                className="mt-1 p-2 w-full border rounded-lg"
                value={adminApiToken}
                onChange={(e) => setAdminApiToken(e.target.value)}
                placeholder="Enter Admin API Token"
              />
            </div>
          </div>

          {/* Note/Disclaimer */}
          <div className="text-xs text-gray-500 italic mb-6">
            Note: Ensure your API credentials are kept secure and not shared
            with unauthorized users.
          </div>

          {/* Error Message */}
          {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

          {/* Buttons */}
          <div className="flex justify-end gap-4">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              onClick={saveShopifyApiCredentials}
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectedPlatformApiConfigurationModal;
